import useIsFromMOF from "./useIsFromMOF"
import { useWelcomeModalStore } from "../../components/modals/WelcomeModal"
import { CoachPaywallChoice } from "../../constants"
import { useRouter } from "../../util/router"
import { localStorageItems } from "../../util/storage"

/**
 * Leave the coaching step and continue wherever the funnel was headed next.
 *
 * Declining coaching is not the end of onboarding — a top-of-funnel user still owes the
 * forced-onboarding chain (welcome -> screen time -> set up child -> download app), which
 * `openWelcomeModal` kicks off by setting `needsToSeeWelcomeModal`. Someone who picked a
 * coach bundle on the paywall instead goes back to choose an app-only plan.
 *
 * Shared by the skip button on the coaching landing page and by the entrypoints that
 * bypass coaching entirely for non-English users, so the two paths stay identical — the
 * language gate should skip one step, not the rest of onboarding with it.
 */
const useSkipCoachingStep = () => {
  const router = useRouter()
  const isFromMOF = useIsFromMOF()
  const { onOpen: openWelcomeModal } = useWelcomeModalStore()

  return () => {
    const planChoice = localStorage.getItem(
      localStorageItems.planChoiceFromPaywall
    )

    if (
      planChoice === CoachPaywallChoice.WITH_COACH ||
      planChoice === CoachPaywallChoice.EXIT_WITH_COACH
    ) {
      router.push("/paywall/trial")
      return
    }

    localStorage.removeItem(localStorageItems.planChoiceFromPaywall)
    router.push("/me")
    if (isFromMOF) return

    openWelcomeModal()
  }
}

export default useSkipCoachingStep
